import { COOKIE_NAMES } from '@/lib/experimentation';
import { BootstrapExperimentsCookie } from '@/lib/experimentation/types';
import { getCurrentExperimentByPathname } from '@/lib/experimentation/useCurrentExperiment';
import { getCookie } from '@/utils/cookies';

const POSTHOG_DISTINCT_ID_QUERY_PARAM = 'ph_d_id';
const EXPERIMENT_ID_QUERY_PARAM = 'exp_id';

function getExperimentIdForPathname(pathname: string): string | null {
  const experiment = getCurrentExperimentByPathname(pathname);

  return experiment?.flagId || null;
}

function isAbsoluteHttpUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

// grabs the posthog distinct Id and experiment ID and appends them to the url
// so dashboard can pick them up and use them to track the rest of the journey on their end
// Note that these params get passed in both all pricing cards, including contact sales card
export const createHrefWithExperimentTracking = (
  url: string,
  pathname: string
) => {
  const experimentId = getExperimentIdForPathname(pathname);

  if (!experimentId || !isAbsoluteHttpUrl(url)) {
    return url;
  }

  const bootstrapExperiments = getCookie(COOKIE_NAMES.BOOTSTRAP_EXPERIMENTS) as
    | BootstrapExperimentsCookie
    | undefined;

  if (!bootstrapExperiments) {
    return url;
  }

  const { distinctID } = bootstrapExperiments;

  if (!distinctID) {
    console.error('No distinctID found in bootstrapExperiments');
    return url;
  }

  try {
    const updatedUrl = new URL(url);

    updatedUrl.searchParams.set(POSTHOG_DISTINCT_ID_QUERY_PARAM, distinctID);
    updatedUrl.searchParams.set(EXPERIMENT_ID_QUERY_PARAM, experimentId);

    return updatedUrl.toString();
  } catch {
    return url;
  }
};
